import styled from "styled-components";

export const CustomContainer = styled("div")`
  padding: 0;

  .ant-card {
    .ant-card-head {
      min-height: 40px;
      padding: 0 16px;
    }
    .ant-card-head-title {
      font-size: 14px;
      font-weight: 600;
      padding: 8px 0;
    }
    .ant-card-body {
      padding: 16px;
    }
  }

  .ant-form-item {
    margin-bottom: 10px;
  }

  .ant-form-item-label {
    padding-bottom: 2px !important;
    > label {
      font-size: 12px;
      height: auto;
      color: #000000;
    }
  }

  .ant-select-focused .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-open .ant-select-selector {
    border-color: #4a6fa5 !important;
    box-shadow: none !important;
  }

  .ant-select {
    width: 100%;
    .ant-select-selector {
      display: flex;
      align-items: center;
      width: 100%;
      height: 32px !important;
      background: #ffffff;
      border-radius: 6px;
      font-size: 13px;
      .ant-select-selection-search {
        input {
          height: 100%;
        }
      }
    }
  }

  .ant-input-number-affix-wrapper {
    .ant-input-number-handler-wrap {
      display: none;
    }
    input {
      height: 32px;
      appearance: none;
      -moz-appearance: textfield;
      padding: 0 !important;
    }
  }

  .ant-input-number-affix-wrapper,
  .ant-input {
    height: 32px;
    width: 100%;
    background: #ffffff;
    border-radius: 6px;
    font-size: 13px;
  }

  .ant-color-picker-trigger {
    height: 32px;
  }
`;
